import { createEntityAdapter, createSlice, EntityState, PayloadAction } from '@reduxjs/toolkit';
import * as Types from 'types';
import { WorkerShift } from 'types';
import { flatten, uniqBy } from 'lodash';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 start
// import {
//   getUnpropertyListShop,
//   getShopWorkersChargeSiteList,
//   getUserSchedules,
//   getCooperatorSchedules,
//   getWorkersSiteList,
//   getWorkersChargeSiteList,
// } from './thunk';
import {
  getUnpropertyListShop,
  getShopWorkersChargeSiteList,
  getUserSchedules,
  getCooperatorSchedules,
  getWorkersSiteList,
  getWorkersChargeSiteList,
  findPropertyInfo,
} from './thunk';
// 2023/10/24 Leading Win 作業員シフト表廃止対応 start

export const workerAdapter = createEntityAdapter<Types.WorkerShift>({
  selectId: (worker) => worker.id,
});
export interface InitialState {
  data: EntityState<Types.WorkerShift>;
  loading: boolean;
  unpropertyListShop: { sites: Types.UnpropertyListShop[]; loading: boolean };
  WorkersSiteListData: { sites: Types.WorkersSiteListItem[]; loading: boolean };
  ShopWorkersChargeSiteList: {
    cooperators: Types.ShopWorkersChargeSiteListCooperators[];
    loading: boolean;
  };
  WorkersChargeSiteList: {
    cooperators: Types.WorkersChargeSiteListCooperators[];
    loading: boolean;
  };
  DataCooperator: Types.ShopSchedulesItemSelect[] | [];
  userSchedules: Types.CooperatorUserSchedulesResponse['users'];
  userSchedulesLoading: boolean;
  cooperatorSchedules: Types.GetShopSchedulesSelectResponse['sites'];
  cooperatorSchedulesLoading: boolean;
  listWorkType: Types.ShopSchedules[];
  listUserSite: Types.ShopSchedulesUserSelect[];
  ganttChartDataCooperator: Types.WorkerShift[];
  ganttChartDataUser: Types.WorkerShift[];
  workersSiteList: Types.getWorkersSiteListResponse['sites'];
  workersSiteListLoading: boolean;
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
  PropertyInfoList: { today: string; site_data: Types.PropertyInfoType[]; loading: boolean };
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
  error_message: string;
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
}

const initialState: InitialState = {
  data: workerAdapter.getInitialState(),
  loading: false,
  unpropertyListShop: { sites: [], loading: false },
  WorkersSiteListData: { sites: [], loading: false },
  ShopWorkersChargeSiteList: { cooperators: [], loading: false },
  WorkersChargeSiteList: { cooperators: [], loading: false },
  DataCooperator: [],
  userSchedules: [],
  userSchedulesLoading: false,
  cooperatorSchedules: [],
  cooperatorSchedulesLoading: false,
  listWorkType: [],
  listUserSite: [],
  ganttChartDataCooperator: [],
  ganttChartDataUser: [],
  workersSiteList: [],
  workersSiteListLoading: false,
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
  PropertyInfoList: { today: '', site_data: [], loading: false },
  // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
  error_message: '',
  // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
};

export const workerShiftSlice = createSlice({
  name: 'worker-shift',
  initialState,
  reducers: {
    getDataCooperator: (state, action) => {
      state.DataCooperator = action.payload;
    },
    updateData: (
      state,
      action: PayloadAction<{
        data: { id: string | number; changes: WorkerShift }[];
      }>
    ) => {
      workerAdapter.updateMany(state.data, action.payload.data);
    },
    cooperatorSchedulesData: (state, { payload }) => {
      workerAdapter.setAll(state.data, payload);
    },
    removeUserSchedules: (state, { payload }) => {
      workerAdapter.removeMany(state.data, payload);
    },
    cooperatorUserSchedules: (state, { payload }) => {
      workerAdapter.upsertMany(state.data, payload);
    },
    addUserSchedulesCooperator: (state, { payload }) => {
      workerAdapter.upsertMany(state.data, payload);
    },
    resetSchedules: (state) => {
      workerAdapter.removeAll(state.data);
    },
    addGanttChartDataCooperator: (state, { payload }) => {
      state.ganttChartDataCooperator = payload;
    },
    addGanttChartDataUser: (state, { payload }) => {
      state.ganttChartDataUser = payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUserSchedules.pending, (state) => {
      state.userSchedules = [];
      state.userSchedulesLoading = true;
    });
    builder.addCase(getUserSchedules.fulfilled, (state, { payload }) => {
      state.userSchedulesLoading = false;
      state.userSchedules = payload.users;
    });
    builder.addCase(getUserSchedules.rejected, (state, { payload }) => {
      state.userSchedulesLoading = false;
      state.userSchedules = [];
    });
    builder.addCase(getCooperatorSchedules.pending, (state) => {
      state.cooperatorSchedules = [];
      state.cooperatorSchedulesLoading = true;
    });
    builder.addCase(getCooperatorSchedules.fulfilled, (state, { payload }) => {
      state.cooperatorSchedulesLoading = false;
      state.cooperatorSchedules = payload.sites;
      state.listWorkType = uniqBy(
        flatten(payload.sites.map((site) => site.schedules)),
        'work_type_id'
      );
      state.listUserSite = flatten(payload.sites.map((item) => item.users));
    });
    builder.addCase(getCooperatorSchedules.rejected, (state, { payload }) => {
      state.cooperatorSchedulesLoading = false;
      state.cooperatorSchedules = [];
    });
    builder.addCase(getUnpropertyListShop.pending, (state) => {
      state.unpropertyListShop.loading = true;
      state.unpropertyListShop.sites = [];
    });
    builder.addCase(getUnpropertyListShop.fulfilled, (state, { payload }) => {
      state.unpropertyListShop = {
        sites: payload.sites,
        loading: false,
      };
    });
    builder.addCase(getUnpropertyListShop.rejected, (state) => {
      state.unpropertyListShop.sites = initialState.unpropertyListShop.sites;
      state.loading = false;
    });
    // getWorkersChargeSiteList
    builder.addCase(getWorkersChargeSiteList.pending, (state) => {
      state.WorkersChargeSiteList.loading = true;
    });
    builder.addCase(getWorkersChargeSiteList.fulfilled, (state, { payload }) => {
      state.WorkersChargeSiteList = {
        cooperators: payload.cooperators,
        loading: false,
      };
    });
    builder.addCase(getWorkersChargeSiteList.rejected, (state) => {
      state.WorkersChargeSiteList.cooperators = initialState.WorkersChargeSiteList.cooperators;
      state.WorkersChargeSiteList.loading = false;
    });
    // getWorkersSiteList
    builder.addCase(getShopWorkersChargeSiteList.pending, (state) => {
      state.ShopWorkersChargeSiteList.loading = true;
    });
    builder.addCase(getShopWorkersChargeSiteList.fulfilled, (state, { payload }) => {
      state.ShopWorkersChargeSiteList = {
        cooperators: payload.cooperators,
        loading: false,
      };
    });
    builder.addCase(getShopWorkersChargeSiteList.rejected, (state) => {
      state.ShopWorkersChargeSiteList.cooperators =
        initialState.ShopWorkersChargeSiteList.cooperators;
      state.ShopWorkersChargeSiteList.loading = false;
    });
    // getWorkersSiteList
    builder.addCase(getWorkersSiteList.pending, (state) => {
      state.workersSiteListLoading = true;
    });
    builder.addCase(getWorkersSiteList.fulfilled, (state, { payload }) => {
      state.workersSiteList = payload.sites;
      state.workersSiteListLoading = false;
    });
    builder.addCase(getWorkersSiteList.rejected, (state) => {
      state.workersSiteListLoading = false;
    });
    // 2023/10/24 Leading Win 作業員シフト表廃止対応 start
    builder.addCase(findPropertyInfo.pending, (state) => {
      state.PropertyInfoList.today = '';
      state.PropertyInfoList.site_data = [];
      state.PropertyInfoList.loading = true;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
      state.error_message = '';
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
    });
    builder.addCase(findPropertyInfo.fulfilled, (state, { payload }) => {
      state.PropertyInfoList = {
        site_data: payload.site_data,
        today: payload.today,
        loading: false,
      };
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
      state.error_message = '';
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
    });
    builder.addCase(findPropertyInfo.rejected, (state, payload: any) => {
      state.PropertyInfoList.site_data = initialState.PropertyInfoList.site_data;
      state.PropertyInfoList.today = initialState.PropertyInfoList.today;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） start
      state.PropertyInfoList.loading = false;
      state.error_message = payload?.payload?.response?.data?.message || payload.error.message;
      // 2024/10/30 Leading Win エラーメッセージ出力表示の対応 DXWEBLOS00100_現場一覧（作業予定現場一覧） end
    });
    // 2023/10/24 Leading Win 作業員シフト表廃止対応 end
  },
});

export const {
  getDataCooperator,
  updateData,
  cooperatorSchedulesData,
  cooperatorUserSchedules,
  resetSchedules,
  addUserSchedulesCooperator,
  removeUserSchedules,
  addGanttChartDataUser,
  addGanttChartDataCooperator,
} = workerShiftSlice.actions;

export default workerShiftSlice.reducer;
